<script lang="ts">
    import {_} from '../services/i18n';
    import {CYCLE_COLORS} from "../config";

    /*
    let cycles = [



        "#C0DFF3",
        "#6B99CD",
        "#4F7FB8",
        "#32639E",
        "#2F3353",
        "#4A7E83",
        "#4E7C67",
        "#6C8E51",
        "#A8B35B",
        "#C5C35A"
    ];
*/
    let cycles = CYCLE_COLORS;
    export let mapType: string = "";

</script>

<div class="legend">
    {#if mapType == 'full'}
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.community')}</span>
            <span class="legend-circle mark-light" style="background: #FAFAFA !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.selectedCommunity')}</span>
            <span class="legend-circle mark-selected-full"
                  style="background: #FDEED6 !important; border-color:#F7A833 !important;"></span>
        </div>
    {:else if mapType == 'pact'}
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.pilotPact')}</span>
            <span class="legend-circle mark-pilot-pact" style="background: #49b170 !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.pact')}</span>
            <span class="legend-circle mark-pact" style="background: #56A8DD !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.pactAndPilot')}</span>
            <span class="legend-circle mark-selected-mixed"
                  style="background: repeating-linear-gradient(135deg, #56A8DD, #C8DBE7 6px, #C2E1CE 6px) !important; border-color: #428AB8 !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.noPactCommunities')}</span>
            <span class="legend-circle mark-dark" style="background: #D0D0D0 !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.selectedCommunity')}</span>
            <span class="legend-circle mark-selected-pilot-pact"
                  style="background: #56A8DD !important; border-color:#428AB8 !important; margin-right:0.25rem !important;"></span>
            <span class="legend-circle mark-selected-pact"
                  style="background: #C2E1CE !important; border-color:#449161 !important; margin-right:0.25rem !important;"></span>
            <span class="legend-circle mark-selected-mixed"
                  style="background: repeating-linear-gradient(135deg, #56A8DD, #C8DBE7 6px, #C2E1CE 6px) !important; border-color: #428AB8 !important;"></span>
        </div>
        <!--
         <div class="legend-item group mobile-100">
             <span class="my-auto" style="margin-bottom:0.4rem!important;">{$_('legend.cycleInfo')}</span>
             <span class="cycle-wrapper">
                 {#each cycles as cycle, index}
                  <span class="cycle-item">
                     <span class="legend-circle" style="background:{cycle}"></span>
                      <span class="cycle-label">{index++}</span>
                  </span>
                 {/each}
             </span>

         </div>
         -->
    {:else}

        <div class="legend-item">
            <span class="my-auto" >{$_('legend.community')}</span>
            <span class="legend-circle mark-light" style="background: #FAFAFA !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto">{$_('legend.selectedCommunity')}</span>
            <span class="legend-circle mark-selected-full"
                  style="background: #FFFFFF !important; border-color:#F7A833 !important;"></span>
        </div>

        <div class="legend-item">
            <span class="my-auto">{$_('legend.pactSigned')}</span>
            <span class="legend-circle"
                  style="background:{cycles[0]}; border: 1px solid {cycles[0]};"></span>
        </div>

        <div class="legend-item">
            <span class="my-auto" >{$_('legend.cycleInfo')}</span>
            <span class="cycle-wrapper">
                {#each cycles as cycle, index}
                      {#if index > 0}
                         <span class="cycle-item">
                            <span class="legend-circle" style="background:{cycle}; border: 1px solid {cycle};"></span>
                             <span class="cycle-label">
                                     {index == 1 ? 'P' : index-1}
                             </span>
                         </span>
                      {/if}
                {/each}
            </span>
        </div>
    {/if}


</div>


<style lang="scss">

  .legend {
    width: auto;
    padding: 24px 22px;
    border-radius: 6px;
    background: #fff;
  }

  .legend-item {
    display: grid;
    grid-template-columns:300px 1fr;
    align-items: center;
    gap: 10px;
    margin-top: 1.5rem;

    &:first-child {
      margin-top: 0;
    }
  }

  .legend-item > span:first-child {
    margin: 0 !important;
  }

  .legend-circle {
    display: block;
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    border: 1px solid #054055;
    justify-self: start;
  }

  .cycle-wrapper {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: nowrap;
  }

  .cycle-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cycle-label {
    margin-top: 0.35rem;
    font-size: 0.75rem;
  }

  /* Keep background color when printing*/
  /*
  color-adjust: exact;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  }
  */

  @media (max-width: 680px) {

    .mobile-100 {

      flex-direction: column;

      .cycle-wrapper {
        margin-top: 1rem;

        .cycle-item:first-child {
          margin-left: 0px;
        }
      }

    }

  }


  //alternative default?
  .mark-light {
    background: #FAFAFA;
  }

  //no pact community or default
  .mark-dark {
    background: #D0D0D0; //rgb(110, 110, 110);
  }

  .mark-pact {
    background: #56A8DD;

  }

  .mark-pilot-pact {
    background: #49b170;
  }

  .mark-selected {
    background: #D5E6F0;
  }


  .mark-selected-pilot-pact {
    background: #56A8DD;
    border-color: #428AB8;
    margin-right: 0.25rem;
  }

  .mark-selected-pact {
    background: #C2E1CE;
    border-color: #449161;
    margin-right: 0.25rem;
  }

  .mark-selected-mixed {
    background: repeating-linear-gradient(
                    135deg,
                    #56A8DD,
                    #C8DBE7 6px,
                    #C2E1CE 6px
    );
    border-color: #428AB8;
  }


  .mark-selected-full {
   background: #FDEED6;
    border-color: #F7A833 !important;
  }


  .mark-mixed-pact {

    background-image: linear-gradient(145deg, #ffffff 15%, #49b170 15%, #49b170 25%, #ffffff 25%, #ffffff 40%, #56a8dd 40%, #56a8dd 50%, #ffffff 50%, #ffffff 65%, #49b170 65%, #49b170 75%, #ffffff 75%, #ffffff 90%, #56a8dd 90%, #56a8dd 100%);
    background-size: 174.34px 122.08px;

  }

</style>
